<template>
  <div class="order-detail">
    <div class="order-detail-left">
      <h3>基本信息</h3>
      <div class="order-detail-info">
        <el-form
          ref="form"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="业务类型：">
            IT运维
          </el-form-item>
          <el-form-item label="业务分类：">
            IT运维
          </el-form-item>
          <el-form-item label="优先级：">
            IT运维
          </el-form-item>
          <el-form-item label="状态：">
            IT运维
          </el-form-item>
          <el-form-item label="标题：">
            IT运维
          </el-form-item>
          <el-form-item label="客户信息：">
            IT运维
          </el-form-item>
          <el-form-item label="事务描述：">
            IT运维
          </el-form-item>
        </el-form>
        <OrderTimeLine/>
      </div>
    </div>
    <div class="order-detail-right">
      <el-form
        label-width="90px"
        :model="orderForm"
        size="small"
      >
        <el-form-item label="处理建议">
          <el-input v-model="orderForm.name"></el-input>
        </el-form-item>
        <el-form-item label="是否结案">
          <el-switch v-model="orderForm.delivery"></el-switch>
        </el-form-item>
        <el-form-item label="通知">
          <el-input v-model="orderForm.type"></el-input>
        </el-form-item>
        <el-form-item label="添加处理人">
          <el-select
            v-model="orderForm.region"
            placeholder="活动区域"
          >
            <el-option
              label="区域一"
              value="shanghai"
            ></el-option>
            <el-option
              label="区域二"
              value="beijing"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import OrderTimeLine from '@/views/components/OrderTimeLine'
export default {
  data() {
    return {
      orderForm: {},
    };
  },
  name: 'PcWorkOrderDetail',
  components: {
    OrderTimeLine,
  },
  methods: {
      onSubmit() {},
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background-color: rgb(238, 241, 249);
  display: flex;
  .order-detail-left,
  .order-detail-right {
    background-color: #fff;
    height: 100%;
    box-shadow: 0 5px 8px 0 rgb(37 46 59 / 8%);
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    width: 260px;
  }
  .order-detail-left {
    width: 260px;
    margin-right: 20px;
    flex-shrink: 0;
  }
  .order-detail-right {
    flex: 1;
  }
  .order-detail-timeline {
    padding-left: 0;
  }
}
</style>

